(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbContentTypeGroupTagTypesConfigDataStore', [
			'$q',
			'smbContentTypeGroupTagTypeConfigService',
			'smbIndexTypesDataTypes',
			ContentTypeGroupTagTypesConfigDataStore
		]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypeGroupTagTypesConfigDataStore
	 *
	 * @description
	 * State management of tag types for content type group configuration.
	 */
	function ContentTypeGroupTagTypesConfigDataStore($q, smbContentTypeGroupTagTypeConfigService, smbIndexTypesDataTypes) {

		var _tagTypes;

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypeGroupTagTypesConfigDataStore#tagTypes
			 * @propertyOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
			 * @kind property
			 *
			 * @description
			 * Get a colleciton of @see TagType objects that have previously been loaded.
			 *
			 * @returns {TagType[]} A collection of @see TagType objects
			 */
			get tagTypes() { return _tagTypes; },

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupTagTypesConfigDataStore#getTagTypes
			 * @propertyOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
			 * @kind function
			 *
			 * @description
			 * Load all tag types for a single content type group.
			 *
			 * @returns {Deferred<TagType[]>} A promise that resolves to a collection
			 * of @see TagType objects.
			 */
			getTagTypes: getTagTypes,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupTagTypesConfigDataStore#addTagType
			 * @propertyOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
			 * @kind function
			 *
			 * @description
			 * Create a new tag type and add it to the tagTypes property
			 *
			 * @returns {Deferred<TagType>} A promise that resolves to the newly
			 * created tag type.
			 */
			addTagType: addTagType,

			/**
			 * @ngdoc method
			 * @name smbContentTypeGroupTagTypesConfigDataStore#editTagType
			 * @methodOf smb-app.smbContentTypeGroupTagTypesConfigDataStore
			 * @kind function
			 *
			 * @description
			 * Saves changes to an existing @see TagType object.
			 *
			 * @param {ObjectId} groupId Id of the document type group that owns the tag type.
			 * @param {TagType} tagType The tag type object to save.
			 *
			 * @returns {Promise<TagType>} A promise that resolves to the saved tag type.
			 */
			editTagType: editTagType
		};

		function getTagTypes(groupId) {
			if (!(typeof groupId === 'number' || typeof groupId === 'string') || groupId === '') {
				_tagTypes = [];
				return $q.resolve(_tagTypes);
			}

			return smbContentTypeGroupTagTypeConfigService.getTagTypes(groupId)
				.then(function(tagTypes) {
					_tagTypes = tagTypes.filter(function filterStatuses(tagtype) {
						return !(tagtype.TagTypeName.match(/&&_AirBase_.*/));
					})
					.map(function(tagType) {
						if (tagType.DataType === smbIndexTypesDataTypes.NUMERIC && tagType.Constraints && tagType.Constraints.DefaultValue) {
							tagType.Constraints.DefaultValue = tagType.Constraints.DefaultValue.indexOf('.') >= 0 ?
								parseFloat(tagType.Constraints.DefaultValue) : parseInt(tagType.Constraints.DefaultValue, 10);
						}

						return tagType;
					});
					return tagTypes;
				});
		}

		function editTagType(groupId, tagType) {
			if (typeof groupId !== 'number' && typeof groupId !== 'string') {
				return $q.reject(new Error('Missing required group id'));
			} else if (!tagType) {
				return $q.reject(new Error('Missing required tag type'));
			} else if (!tagType.TagTypeName) {
				return $q.reject(new Error('The tag type must have a name'));
			} else if (!smbIndexTypesDataTypes[tagType.DataType]) {
				return $q.reject(new Error('The tag type must have a data type'));
			} else if (!tagType.TagTypeId) {
				return $q.reject(new Error('Missing required tag type id'));
			}

			return smbContentTypeGroupTagTypeConfigService.editTagType(groupId, tagType)
				.then(function(data) {
					if (!_tagTypes) {
						_tagTypes = [];
					}
					_tagTypes = _tagTypes.map(function(tt) { return tt.TagTypeId === tagType.TagTypeId ? data : tt; });
				});
		}

		function addTagType(groupId, tagType) {
			if (typeof groupId !== 'number' && typeof groupId !== 'string') {
				return $q.reject(new Error('Missing required group id'));
			} else if (!tagType) {
				return $q.reject(new Error('Missing required tag type'));
			} else if (!tagType.TagTypeName) {
				return $q.reject(new Error('The tag type must have a name'));
			} else if (!smbIndexTypesDataTypes[tagType.DataType]) {
				return $q.reject(new Error('The tag type must have a data type'));
			}

			return smbContentTypeGroupTagTypeConfigService.createTagType(groupId, tagType)
				.then(function(data) {
					if (!_tagTypes) {
						_tagTypes = [];
					}
					_tagTypes.push(data);
					return data;
				});
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentConfigDataStores/contentTypeGroupTagTypesConfigDataStore.js
// module id = 108
// module chunks = 1